var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',[_c('h3',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t("welcome"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }